import { render, staticRenderFns } from "./BaseSOF.vue?vue&type=template&id=248ff764&scoped=true&"
import script from "./BaseSOF.vue?vue&type=script&lang=js&"
export * from "./BaseSOF.vue?vue&type=script&lang=js&"
import style0 from "./BaseSOF.vue?vue&type=style&index=0&id=248ff764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248ff764",
  null
  
)

export default component.exports